import { render, staticRenderFns } from "./FaqForm.vue?vue&type=template&id=d15cf6a2"
import script from "./FaqForm.vue?vue&type=script&lang=js"
export * from "./FaqForm.vue?vue&type=script&lang=js"
import style0 from "./FaqForm.vue?vue&type=style&index=0&id=d15cf6a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports